import React, { Component } from 'react';
import * as d3 from "d3";
import * as d3pie from "d3pie";

import StringUtils from '../../services/StringUtils.js';

class PieChart extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: props.data,
      type: props.type,
      label: props.label,
      clickCb: props.clickCb
    }

  }

  componentWillReceiveProps(newProps) {
    
    this.setState({
      data: newProps.data,
      type: newProps.type,
      label: newProps.label,
      clickCb: newProps.clickCb
    });

    this.renderPieChart();

  }

  componentDidMount() {
    this.eventHandler = this.updateDimensions.bind(this);
    this.renderPieChart();
    window.addEventListener("resize", this.eventHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  }

  updateDimensions() {
    let data = this.state.data;
    if (!data || (this.lastWidth && this.lastWidth === this.getWidth()))
      return;
    this.renderPieChart();
  }

  getWidth() {
    let width = document.getElementById('container').offsetWidth*0.95;
    return width;
  }

  isLargeEnough() {
    return this.getWidth() >= 550;
  }

  renderPieChart() {

    let data = this.state.data;
    let type = this.state.type;
    let onClickCb = this.state.clickCb;

    if (!data)
      return;

    if (this.refs.pieChart)
      d3.select(this.refs.pieChart).html('');

    let width =  this.getWidth();
    this.lastWidth = width;
    let height = this.isLargeEnough() ? 450 : 350;
    
    data = data.items.map(function(item){ return { label: StringUtils.titleize(item.key), value: item.value }  });

    d3pie.default(this.refs.pieChart, {
      "size": {
        "canvasHeight": height,
        "canvasWidth": width,
        "pieOuterRadius": "100%"
      },
      "data": {
        "smallSegmentGrouping": {
          "enabled": false,
          "value": 2
        },
        "content": data
      },
      header: {
        "title": {
          "font": "open sans",
          "text": ' '
        }
      },
      "labels": {
        "outer": {
          "pieDistance": this.isLargeEnough() ? 32 : 10,
          "hideWhenLessThanPercentage": 2,
        },
        "inner": {
          "format": "value",
          "hideWhenLessThanPercentage": 4
        },
        "mainLabel": {
          "color": "#ffffff",
          "font": "verdana",
        },
        "percentage": {
          "color": "#e1e1e1",
          "decimalPlaces": 0
        },
        "value": {
          "color": "#e1e1e1",
          "font": "verdana",
          "fontSize": 15
        },
        "lines": {
          "enabled": true
        },
        "truncation": {
          "enabled": true
        }
      },
      "tooltips": {
        "enabled": true,
        "type": "placeholder",
        "string": "{label}: {value} ~ {percentage}%",
        "styles": {
          "backgroundOpacity": 0.6,
          "borderRadius": 3,
          "padding": 7
        }
      },
      "effects": {
        "pullOutSegmentOnClick": {
          "effect": "linear",
          "speed": 400,
          "size": 8
        }
      },
      "misc": {
        "canvasPadding": {
          "top": this.isLargeEnough() ? 30 : 40,
          "bottom": this.isLargeEnough() ? 30 : 40,
          "left": this.isLargeEnough() ? 30 : 60,
          "right": this.isLargeEnough() ? 30 : 60
        }
      },
      "callbacks": {
        onClickSegment: function(evt){
          let name = evt.data.label;
          let lowerCaseName = name.toLowerCase();
          if (lowerCaseName !== 'others' && lowerCaseName !== 'other')
          {
             onClickCb(name, type);
          }
        }
      }
    });
   
  }

  render() {

    let className = this.isLargeEnough() ? 'pie large' : 'pie';

    return (
      <div className={className} ref="pieChart">
      </div> 
    );
  }

}

export default PieChart;



// WEBPACK FOOTER //
// ./src/js/components/charts/PieChart.jsx